import {
  channelOptions,
  countryDomainOptions,
  channelByCountryDomain,
  channelWidthOptions,
  wirelessModeOptions,
  txPowerOptions,
  rssiOptions,
} from "utils/channel-options/const";

export const defaultAlertInfo = {
  open: false,
  severity: "",
  message: "",
}

export const defaultActions = {
  isUpdate: false,
}

export const defaultBandTabs = [
  { label: "2.4 GHz", value: "2", key: "2.4GHz", isSelected: true },
  { label: "5 GHz", value: "5", key: "5GHz", isSelected: false },
  { label: "6 GHz", value: "6", key: "6GHz", isSelected: false },
];

export const defaultChannels = {
  "2": [],
  "5": [],
  "6": [],
}

export const defaultChannelWidths = {
  "2": channelWidthOptions["2.4GHz"].map(chw => ({ ...chw, isSelected: chw.value === "Auto" })),
  "5": channelWidthOptions["5GHz"].map(chw => ({ ...chw, isSelected: chw.value === "Auto" })),
  "6": [
    { value: "20", label: "20 MHz", isSelected: false },
    { value: "40", label: "40 MHz", isSelected: false },
    ...channelWidthOptions["6GHz"].map(chw => ({ ...chw, isSelected: chw.value === "Auto" }))
  ]
}

export const defaultWirelessModes = {
  "2": wirelessModeOptions["2.4GHz"].map(mode => ({ ...mode, isSelected: mode.value === "Auto" })),
  "5": wirelessModeOptions["5GHz"].map(mode => ({ ...mode, isSelected: mode.value === "Auto" })),
  "6": wirelessModeOptions["6GHz"].map(mode => ({ ...mode, isSelected: mode.value === "Auto" })),
}

const defaultTxPower = [
  { value: 0, label: "Auto", isSelected: true },
  ...txPowerOptions.map(power => ({ ...power, isSelected: false }))
]

export const defaultTxPowers = {
  "2": defaultTxPower,
  "5": defaultTxPower,
  "6": defaultTxPower
};

export const defaultUtilizationList = [
  { value: 100, label: "100", isSelected: true },
  { value: 80, label: "80", isSelected: false },
  { value: 60, label: "60", isSelected: false },
  { value: 40, label: "40", isSelected: false },
  { value: 20, label: "20", isSelected: false },
  { value: 0, label: "0", isSelected: false }
];

export const defaultRSSIThresholdList = rssiOptions
.filter(rssi => rssi.value !== "Disable")
.map(rssi => ({ ...rssi, isSelected: rssi.value === 10 }))

export const defaultStartTimeList = Array.from({ length: 48 }, (item, index) => {
  const hr = String(Math.floor(index / 2)).padStart(2, "0");
  const min = index % 2 === 0 ? "00" : "30";
  const value = `${hr}:${min}`;

  return { label: value, value, isSelected: false };
});
